/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {disable, pxToEm} from '@insticator/insticator-ui'; // iui-utils
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT : EMBED REVENUE : STYLES --------------- ++++++++++ */
export default theme => ({
	addons: {
		'& .list':{
			position: 'relative',
			zIndex: 2
		},
		'&.saving-true': {
			extend: disable
		},
		'& .addoncard': {
			opacity: '0',
			animationName: 'fadeInUp',
			animationDelay: '.75s',
			animationDuration: '.2s',
			animationFillMode: 'forwards',
		}
	}
});
